import { Link } from "react-router-dom";
import { PublicHeader, Footer } from "../components/PublicChrome";
import { OrgChart } from "../components/heritage/OrgChart";
import { useApi } from "../lib/api";
import { SOURCES } from "../lib/heritage";

const OWN = { DGC: "pill-green", "Kennedy Osei": "pill-blue" };

export default function Organisation() {
  const { data } = useApi("/public/entities");
  return (
    <div data-testid="organisation-page">
      <PublicHeader />
      <section className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        <div className="eyebrow mb-4">The Organisation</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-ink max-w-4xl">The structure of DESPITE.</h1>
        <p className="text-ink-3 mt-4 max-w-2xl">Leadership, divisions and every registered entity — with ownership and the principal each answers to.</p>
        <div className="mt-14"><OrgChart /></div>
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-10">
        <div className="eyebrow mb-4">Entity register</div>
        <div className="panel overflow-x-auto">
          <table className="w-full text-sm min-w-[760px]" data-testid="entity-register">
            <thead><tr className="text-left text-xs text-ink-3 border-b border-[color:var(--line)] bg-[#F4F8F5]"><th className="p-3">Registered entity</th><th>Known as</th><th>Sector</th><th>Ownership</th><th>Principal(s)</th></tr></thead>
            <tbody>
              {(data || []).map((e) => (
                <tr key={e.name} className="border-b border-[color:var(--line)]/60">
                  <td className="p-3 text-ink font-semibold">{e.name}</td><td className="text-ink-2">{e.brands.length ? e.brands.map((s) => <Link key={s} to={`/entities/${s}`} className="block text-brand-green hover:underline" data-testid={`register-link-${s}`}>{s.replace(/-/g, " ")} →</Link>) : e.known_as}</td><td className="text-ink-3">{e.sector}</td>
                  <td><span className={`pill ${OWN[e.ownership] || "pill-gold"}`}>{e.ownership}</span></td>
                  <td className="text-[12px] text-ink-3">{e.principals.join(", ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-6 text-[11px] text-ink-3 space-y-1">
          {Object.values(SOURCES).map(([l, u]) => <div key={l}>{u ? <a href={u} target="_blank" rel="noreferrer" className="hover:text-brand-green">Source: {l} ↗</a> : `Source: ${l}`}</div>)}
        </div>
      </section>
      <Footer />
    </div>
  );
}
